prodproApp.controller('ToolController', ['$scope', '$http', '$location', '$modal', '$log', '$timeout', 'alertService', function ($scope, $http, $location, $modal, $log, $timeout, alertService) {
    var vm = this;
    var base_url = api_prefix + 'tools/list';
    var msg;
    vm.showNewToolForm = false;
    vm.sort_url = api_prefix + 'tools/sort';
    vm.resource_url = api_prefix + 'tools';
    vm.objText = {
        singular: 'tool',
        plural: 'tools'
    };
    vm.file_model = 'App\\Repos\\Tools\\Tool';
    vm.showFavoriteAddForm = false;
    vm.error_bag = {};
    vm.favoriteToolList =[];
    vm.cuttingTypeList = [];



    // Mixin Module functionality.
    angular.extend(this, new ModuleController(vm, base_url, $http, $location, $log, $modal));
    angular.extend(this, new SortController(vm, $http, $modal, $timeout));

    vm.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif';
    angular.extend(this, new FileController(vm, $scope, $http, $modal, $timeout));

    vm.initDefaultObj = function() {
        vm.defaultObj.name = '[New Tool]';
        vm.defaultObj.collet_id = "";
        vm.defaultObj.cutting_tool_id = "";
        vm.defaultObj.new_tool_size = "";
        vm.defaultObj.dec_eq_in = "";
        vm.defaultObj.dec_eq_mm = "";
        vm.defaultObj.cutting_type_id = "";
        vm.defaultObj.cutting_type_description_id = "";
        vm.defaultObj.edi =  "";
        vm.defaultObj.holder_id = "";
        vm.defaultObj.insert_grade_id = "";
        vm.defaultObj.insert_id = "";
        vm.defaultObj.location_id = "";
        vm.defaultObj.manufacturer_id = "";
        vm.defaultObj.material_id = "";
        vm.defaultObj.notes = "";
        vm.defaultObj.offset_1 = "";
        vm.defaultObj.offset_2 = "";
        vm.defaultObj.pocket_id = "";
        vm.defaultObj.sleeve_id = "";
        vm.defaultObj.station_id = "";
        vm.defaultObj.stickout_length = "";
        vm.defaultObj.favorite = false;
        vm.defaultObj.error_bag = {};
    };

    vm.loadDataSuccess = function() {
        vm.loadCuttingTypes(context_id);
        for (var i = 0; i < vm.data.data.length; i++) {
            vm.onCuttingToolTypeChange(i);
            vm.onCuttingTypeDescriptionChange(i);
        }

        setTimeout(function(){
            jQuery('textarea').autogrow();
            vm.loadFavoriteTools();
            turnOnTooltips();
        }, 10);

    };

    vm.loadFavoriteTools = function() {
        var cutting_type = cuttingType_id.value;
        var userToolData = [];
        $http({
            method: 'post',
            url: api_prefix + "tools/user-tools",
            data: {id: cuttingType_id.value}
        }).success(function (data) {
            var test=[data.data];
            vm.userToolList = data.data;
            vm.userToolList.sort(strCompare);
            setTimeout(function(){
                jQuery('select[name="cuttingType_id"]').each(function(index){
                    $(this).removeAttr("no-chosen")
                    $(this).chosen();
                });
                jQuery('select[name="favorite_tool_id"]').each(function(index){
                    $(this).removeAttr("no-chosen")
                    $(this).chosen();
                    $(this).trigger('chosen:updated');
                });

            }, 100);
        }).error(function (data) {
            console.log(data);
        });
    };

    vm.loadCuttingTypes = function() {
        $http({
            method: 'post',
            url: api_prefix + "tools/cutting_types",
            data: {context_id: context_id}
        }).success(function (data) {
            vm.cuttingTypeList = data.data;
        }).error(function (data) {
            $log.error(data);
        });
    };

    vm.sortSuccess = function() {
    };

    vm.loadDropdownSuccess = function() {
        vm.loadData();
    };

    vm.onCuttingToolTypeChange = function (index) {
        // ***************************** refresh cutting tool list ************************** //
        var tool = vm.data.data[index];
        tool.cuttingToolList = [];
        $http({
            method: 'POST',
            url: vm.resource_url + "/cutting-tools",
            data: {id: tool.cutting_type_id}
        }).success(function (data) {
            var tool = vm.data.data[index];
            var cuttingToolData = [];

            cuttingToolData.push({id: '',full_name: '[Select Cutting Tool]',name: '[Select Cutting Tool]'});

            angular.forEach(data.data, function (item,key) {
                var full_name = '';
                if (item.size) {
                    full_name = full_name +  item.size;
                }
                if (item.dec_eq_in) {
                    full_name = full_name + '[' + item.dec_eq_in + ' in./' + item.dec_eq_mm +' mm.] ';
                }
                item.full_name = full_name;

                cuttingToolData.push(item);
            });
            tool.cuttingToolList = cuttingToolData;
            vm.onCuttingToolChange(index);

            setTimeout(function(){
                jQuery('select[name="cutting_tool_id"]').each(function(index){
                    $(this).trigger('chosen:updated');
                });
                jQuery('select[name="cutting_type_id"]').each(function(index){
                    $(this).trigger('chosen:updated');
                });
            }, 50);
        }).error(function (data) {
            console.log(data);
        });
        // ********************************* Cutting Type Description Update code *********************************
         var tool = vm.data.data[index];
        tool.cuttingTypeDescriptionList = [];
        $http({
            method: 'POST',
            url: vm.resource_url + "/cutting-type-descriptions",
            data: {id: tool.cutting_type_id}
        }).success(function (data) {
            var tool = vm.data.data[index];
            var cuttingTypeDescriptionData = [];

            cuttingTypeDescriptionData.push({id: '',full_name: '[Select Description]',name: '[Select Description]'});

            angular.forEach(data.data, function (item,key) {
                var full_name = '';
                if (item.description) {
                    full_name =  item.description;
                }
                item.full_name = full_name;

                cuttingTypeDescriptionData.push(item);
            });
            tool.cuttingTypeDescriptionList = cuttingTypeDescriptionData;
            vm.onCuttingTypeDescriptionChange(index);

            setTimeout(function(){
                jQuery('select[name="cutting_type_description_id"]').each(function(index){
                    $(this).trigger('chosen:updated');
                });
            }, 50);
        }).error(function (data) {
           console.log(data);
        });
        // ****************************** end cutting type description update code *********************************//
    };

    vm.onCuttingToolChange = function (index) {
        var tool = vm.data.data[index];
        tool.name = vm.cuttingToolName(tool);
    };

    vm.cuttingToolName = function (tool) {
        if (tool.cuttingToolList !== undefined) {
            for (i = 0; i < tool.cuttingToolList.length; i++) {
                if (tool.cutting_tool_id == tool.cuttingToolList[i].id) {
                    return tool.cuttingToolList[i].full_name;
                }
            }
        }
        return "[Select Cutting Tool]";
    };
    vm.cuttingToolID = function (tool) {
        if (tool.cuttingToolList !== undefined) {
            for (i = 0; i < tool.cuttingToolList.length; i++) {
                if (tool.cutting_tool_id == tool.cuttingToolList[i].id) {
                    return tool.cuttingToolList[i].id;
                }
            }
        }
        return "";
    };

    vm.onCuttingTypeDescriptionChange = function (index) {
        var tool = vm.data.data[index];
        tool.name = vm.cuttingTypeDescriptionName(tool);
    };

    vm.cuttingTypeDescriptionName = function (tool) {
        if (tool.cuttingTypeDescriptionList !== undefined) {
            for (i = 0; i < tool.cuttingTypeDescriptionList.length; i++) {
                if (tool.cutting_type_description_id == tool.cuttingTypeDescriptionList[i].id) {
                    return tool.cuttingTypeDescriptionList[i].description;
                }
            }
        }
        return "[Select Description]";
    };

    vm.cuttingTypeDescriptionID = function (tool) {
        if (tool.cuttingTypeDescriptionList !== undefined) {
            for (i = 0; i < tool.cuttingTypeDescriptionList.length; i++) {
                if (tool.cutting_type_description_id == tool.cuttingTypeDescriptionList[i].id) {
                    return tool.cuttingTypeDescriptionList[i].id;
                }
            }
        }
        return "";
    };

    vm.first = function(obj) {
        for (var a in obj) return a;
    };


    vm.reloadDropdowns = function() {
        if (vm.dropdown_url) {
            $http({
                method: 'GET',
                url: vm.dropdown_url,
                params: {'op_id' : context_id}
            }).success(function (data) {
                vm.dropdowns = data.data;
            });
        }
    };

    vm.loadDropdowns(vm.resource_url + '/dropdowns', {'op_id': context_id});

    vm.openToolEditWindow = function (id){
        var myURL = /cutting_tools/ + id + '/edit';
        if (id > 0) {
            window.open(myURL, "toolEditWindow");
        }

    };

    vm.displayNewToolForm = function(tool){
        vm.showNewToolForm = !vm.showNewToolForm;
        tool.dec_eq_in = '';
        tool.dec_eq_mm = '';
        tool.new_tool_size ='';
        tool.error_bag ={};
    };

    /********************************* Favorite Tools section ************************/
    vm.onFavoriteClick = function(tool){
        if (!tool.favorite){
            $http({
                method: 'GET',
                url: api_prefix + "tools/" + tool.id + "/favorite",
            }).success(function (data) {
                setTimeout(function(){
                    vm.loadData();
                }, 30);
            }).error(function (data) {
            });
        } else {
            $http({
                method: 'GET',
                url: api_prefix + "tools/" + tool.id + "/favorite/remove",
            }).success(function (data) {
                setTimeout(function(){
                    vm.loadData();
                }, 30);
            }).error(function (data) {
                console.log(data);
            });

        }
    };

    vm.displayFavoriteAddForm = function(){
        $scope.cuttingType_id = "";
        setTimeout(function(){
            jQuery('select[name="cuttingType_id"]').each(function(index){
                $(this).trigger('chosen:updated');
            });
        }, 10);

        vm.showFavoriteAddForm = !vm.showFavoriteAddForm;

    };

    vm.addFavoriteToolToOp = function() {
        $http({
            method: 'post',
            url: api_prefix + "tools/add-to-op",
            data: {
                tool_id: $scope.favorite_tool_id,
                op_id:  context_id
            }
        }).success(function (data) {
            $scope.favorite_tool_id = "";
            $scope.cuttingType_id = "";
            setTimeout(function(){
                vm.loadData();
                vm.displayFavoriteAddForm();
            }, 10);
        }).error(function (data) {
            console.log(data);
            vm.error_bag = data;
        });


    };

    /************************************** end favorite tool section *********************************/

    vm.addNewTool = function(tool, index){
        var tool=vm.data.data[index];
        var myURL = '/cutting_tools/store';
        $http({
            method: 'POST',
            url: myURL,
            data: {
                tool_cutting_type_id: tool.cutting_type_id,
                tool_size: tool.new_tool_size,
                tool_dec_eq_in: tool.dec_eq_in,
                tool_dec_eq_mm: tool.dec_eq_mm,
            }
        }).success(function (data) {

            tool.cutting_tool_id = data.id;
            vm.displayNewToolForm(tool);
            vm.onCuttingToolTypeChange(index);
            setTimeout(function(){
                jQuery('select[name="cutting_tool_id"]').each(function(index){
                    $(this).trigger('chosen:updated');
                });
            }, 50);
            ppnotify('alert', {
                'title': 'Success',
                'type': 'info',
                'message': 'Tool size ' + data.name + ' successfully added.',
            });
        }).error(function (data) {
            msg ='Could not add tool. ';
            $log.error(data);
            tool.error_bag = data;
            if (data.tool_dec_eq_in){
                msg = msg + data.tool_dec_eq_in[0];

            }
            if (data.tool_dec_eq_mm){
                msg = msg + data.tool_dec_eq_mm[0];

            }
            if (data.tool_size){
                msg = msg + data.tool_size[0];
            }
            if (data.error){
                msg = msg + data.error;
                ppnotify('alert', {
                    'title': 'Error',
                    'type': 'error',
                    'message': msg,
                });

            }

        });


    };

}]);